import React from 'react';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';

const PERSONAS = [
  { name: 'Ignacio del Pino', ext: '4158', email: 'pinoignacio@uniovi.es', initial: 'I' },
  { name: 'Gema Martínez',   ext: '4166', email: 'gema@uniovi.es',          initial: 'G' },
];

const QueriesComponent = () => {
  return (
    <div>
      {/* Header */}
      <div style={{ paddingTop: 28, paddingBottom: 4, textAlign: 'center', background: '#fafafa' }}>
        <div style={{
          fontSize: 22, fontWeight: 700, color: '#1a1a1a',
          letterSpacing: -0.3, lineHeight: 1.3,
          fontFamily: "'Inter','Segoe UI',sans-serif",
          padding: '0 24px',
        }}>
          Contacta
        </div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 6, paddingBottom: 16 }}>
          Gestión de Acuerdos Transformativos · Subdirección Técnica, de Cooperación Bibliotecaria y Servicios a Distancia
        </div>
      </div>

      <div style={{ padding: '32px 48px 48px', maxWidth: 860, margin: '0 auto' }}>
        {/* Person cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginBottom: 28 }}>
          {PERSONAS.map((p, i) => (
            <div key={i} style={{
              background: '#fff',
              borderRadius: 10,
              boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
              borderTop: '3px solid #007398',
              padding: '24px 28px',
            }}>
              {/* Avatar */}
              <div style={{
                width: 44, height: 44, borderRadius: '50%',
                background: '#007398', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 20, fontWeight: 700, marginBottom: 12,
              }}>
                {p.initial}
              </div>
              {/* Name */}
              <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', marginBottom: 12 }}>
                {p.name}
              </div>
              {/* Contact rows */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 7, fontSize: 13.5, color: '#555' }}>
                <span>
                  <PhoneOutlined style={{ marginRight: 8, color: '#007398' }} />
                  Ext. {p.ext}
                </span>
                <span>
                  <MailOutlined style={{ marginRight: 8, color: '#007398' }} />
                  <a href={`mailto:${p.email}`} style={{ color: '#007398' }}>{p.email}</a>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* General email */}
        <div style={{
          textAlign: 'center', fontSize: 13.5, color: '#666', lineHeight: 1.75,
          padding: '16px 20px', background: '#f6fbfc',
          borderRadius: 8, borderTop: '1px solid #e0eff4',
        }}>
          También pueden enviarse consultas al correo electrónico general de la sección de Sistemas, aplicaciones y proyectos:{' '}
          <a href="mailto:accesoabierto@uniovi.es" style={{ color: '#007398', fontWeight: 600 }}>
            accesoabierto@uniovi.es
          </a>
        </div>
      </div>
    </div>
  );
};

export default QueriesComponent;

